import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { HttpService } from '@kontent-ai/core-sdk';
import { ElementQuery, ItemsFeedQuery, MultipleItemsQuery, MultipleTypeQuery, SingleItemQuery, SingleTypeQuery, TaxonomiesQuery, TaxonomyQuery, LanguagesQuery, InitializeSyncQuery, SyncChangesQuery } from '../query';
import { sdkInfo } from '../sdk-info.generated';
import { MappingService, QueryService } from '../services';
export var DeliveryClient =
/*#__PURE__*/
function () {
  /**
   * Delivery client used to fetch data from Kontent.ai
   * @constructor
   * @param {IDeliveryClientConfig} config - The client configuration
   */
  function DeliveryClient(config) {
    _classCallCheck(this, DeliveryClient);

    this.config = config;

    if (!config) {
      throw Error("Delivery client configuration is not set");
    }

    this.mappingService = new MappingService(config);
    this.queryService = new QueryService(config, config.httpService ? config.httpService : new HttpService(), {
      host: sdkInfo.host,
      name: sdkInfo.name,
      version: sdkInfo.version
    }, this.mappingService);
  }
  /**
   * Gets query for multiple languages
   */


  _createClass(DeliveryClient, [{
    key: "languages",
    value: function languages() {
      return new LanguagesQuery(this.config, this.queryService);
    }
    /**
     * Gets query for multiple types
     */

  }, {
    key: "types",
    value: function types() {
      return new MultipleTypeQuery(this.config, this.queryService);
    }
    /**
     * Gets query for single type
     * @param {string} typeCodename - Codename of the type to fetch
     */

  }, {
    key: "type",
    value: function type(typeCodename) {
      return new SingleTypeQuery(this.config, this.queryService, typeCodename);
    }
    /**
     * Gets query for multiple items
     */

  }, {
    key: "items",
    value: function items() {
      return new MultipleItemsQuery(this.config, this.queryService);
    }
    /**
     * Gets query for single item
     * @param {string} codename - Codename of item to fetch
     */

  }, {
    key: "item",
    value: function item(codename) {
      return new SingleItemQuery(this.config, this.queryService, codename);
    }
    /**
     * Gets query for items feed. Executes single HTTP request only. Might not get all items from your Kontent.ai project.
     */

  }, {
    key: "itemsFeed",
    value: function itemsFeed() {
      return new ItemsFeedQuery(this.config, this.queryService);
    }
    /**
     * Gets query for single taxonomy
     * @param {string} codename - Codename of taxonomy to fetch
     */

  }, {
    key: "taxonomy",
    value: function taxonomy(codename) {
      return new TaxonomyQuery(this.config, this.queryService, codename);
    }
    /**
     * Gets query for multiple taxonomies
     */

  }, {
    key: "taxonomies",
    value: function taxonomies() {
      return new TaxonomiesQuery(this.config, this.queryService);
    }
    /**
     * Gets query for an element within a type
     * @param {string} typeCodename - Codename of the type
     * @param {string} elementCodename - Codename of the element
     */

  }, {
    key: "element",
    value: function element(typeCodename, elementCodename) {
      return new ElementQuery(this.config, this.queryService, typeCodename, elementCodename);
    }
    /**
     * Gets query for initializing sync
     */

  }, {
    key: "initializeSync",
    value: function initializeSync() {
      return new InitializeSyncQuery(this.config, this.queryService);
    }
    /**
     * Gets query fetching delta updates of content items
     */

  }, {
    key: "syncChanges",
    value: function syncChanges() {
      return new SyncChangesQuery(this.config, this.queryService);
    }
  }]);

  return DeliveryClient;
}();